module.exports = __webpack_public_path__ + "media/images/flags/id-a869fd327a1a08cdb324e73a2478a54a.svg";